import { Typography } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";

const DropdownTitle = ({ label, children, sx = {} }) => {
  return (
    <div className="flex w-fit h-full items-center justify-between">
      <Typography
        className="text-[14px]"
        sx={{
          color: HNSColors.neutrals[500],
          fontWeight: "600",
          ...sx,
        }}
      >
        {`${label}`}
      </Typography>
      {children}
    </div>
  );
};

export default DropdownTitle;
